import * as React from "react";
import { Paragraph } from "scuid-x";
import { GenErrorPage } from "../components/GenErrorPage";

export const UuidNotFound: React.SFC<any> = () => {

  const description = (
      <Paragraph>
        There was a problem verifying your link. Please return to your logged in device and generate a new link.
      </Paragraph>
    );

  return (
    <GenErrorPage
      title="Invalid Link"
      description={description}
    />
  );
};



// WEBPACK FOOTER //
// ./src/screens/UuidNotFound.tsx